module.exports = __webpack_public_path__ + "img/5.ed46e7c9.jpg";